import React, {useEffect, useRef, useState} from "react"
import {NavLink, useNavigate} from "react-router-dom"

import "./Test.css"
import iconFolder from "../../assets/iconFolder.svg"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import {getCode, getDateString, getOrderedList, retrieveData, sendRequest} from "../../common";
import Modal from 'react-modal';
import TestResult from "./TestResult";
import {useReactToPrint} from "react-to-print";
import ClipLoader from "react-spinners/ClipLoader";

function PersonalResult() {

	const navigate = useNavigate()

	const [user, setUser] = useState()
	const [applyTests, setApplyTests] = useState([])
	const [type, setType] = useState('PTS 심리유형탐색')

	const [targetGroup, setTargetGroup] = useState('')
	const [order, setOrder] = useState('')

	const [open, setOpen] = useState(false)
	const [id, setId] = useState()

	const [selected, setSelected] = useState([])
	const [isLoading, setIsLoading] = useState(false)

	const getApplyTests = (user) => {
		setIsLoading(true)
		sendRequest(`test/apply-test/?size=1000&sender=${user?.id}&type=${type}&isDone=True&group=개인&targetGroup=${targetGroup}`, 'GET', null, data => {
			setApplyTests(data)
			setIsLoading(false)
		}, data => {
			setIsLoading(false)
		})
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			if (!user || !user?.isExpert) {
				alert('전문가 회원만 볼 수 있습니다.')
				navigate(-1)
				return
			}
			getApplyTests(user)
		})

	}, [])

	useEffect(() => {
		getApplyTests(user)
	}, [type, targetGroup])

	const onSelected = (checked, id) => {
		if (checked) {
			selected.push(id)
			setSelected(Object.assign([], selected))
		} else {
			const index = selected.indexOf(id)
			if (index !== -1) {
				selected.splice(index)
				setSelected(Object.assign([], selected))
			}
		}
	}

	const sendResult = (ids) => {
		if(!ids?.length) {
			alert('내보내기 할 검사를 선택해주세요.')
			return
		}
		if(window.confirm('선택한 항목들의 결과를 보내시겠습니까?')) {
			sendRequest('test/send-result/', 'POST', {
				applyTestIds: ids
			}, data => {
				alert(data?.msg)
			})
		}
	}

	useEffect(() => {
		setApplyTests(Object.assign([], getOrderedList(applyTests, 'doneDateTime', order !== '최근 순')))
	}, [order])

	return (
		<div>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"개인검사 결과보기"} />
					<div className="testWrap">
						<ul className="resultTab">
							<li>
								<NavLink to="blank" className={type === 'PTS 심리유형탐색' ? "active" : null} onClick={e => {
									e.preventDefault()
									setType('PTS 심리유형탐색')
								}}>
									PTS 심리유형탐색
								</NavLink>
							</li>
							<li>
								<NavLink to="blank" className={type === 'PTS 도형심리탐색' ? "active" : null} onClick={e => {
									e.preventDefault()
									setType('PTS 도형심리탐색')
								}}>PTS 도형심리탐색</NavLink>
							</li>
						</ul>
						<section className="personalResult">
							<form name="personalResult">
								<h4>명단 기재</h4>
								<div className="tableTab">
									<div className="tableBtn">
										<button type="button" className="addBtn" onClick={() => getApplyTests(user)}>
											새로고침
										</button>
										<button type="button" className="downBtn"
														onClick={e => {
															e.preventDefault()
															if(selected?.length > 50) {
																alert('한번에 50개 까지만 보낼 수 있습니다.')
																return
															}
															setTimeout(() => window.open(`/test-results/${selected?.toString()}`), 500)
														}}
										>
											데이터 내보내기
										</button>
										<button type="button" className="downBtn"
														onClick={e => {
															e.preventDefault()
															sendResult(selected)
														}}
										>
											전체 결과 발송하기
										</button>
										{/*<button type="button">선택 삭제</button>*/}
										{/*<button type="button" className="fileBtn">*/}
										{/*	<img src={iconFolder} alt="폴더 선택" /> <span>...</span>*/}
										{/*</button>*/}
									</div>
									<div className="tableSearch">
										<span className="selectWrap">
											<select name="" onChange={e => setTargetGroup(e.target.value)}>
												<option value={''}>규준집단</option>
												<option value={'일반 성인'}>일반 성인</option>
												<option value={'대학생'}>대학생</option>
												<option value={'고등학생'}>고등학생</option>
												<option value={'중학생'}>중학생</option>
												<option value={'초등학생'}>초등학생</option>
											</select>
										</span>
										<span className="selectWrap">
											<select name="" onChange={e => setOrder(e.target.value)}>
												<option value={''}>시간순서</option>
												<option value={'최근 순'}>최근 순</option>
												<option value={'오래된 순'}>오래된 순</option>
											</select>
										</span>
									</div>
									<span>총 {selected?.length}명</span>
								</div>
								<div className="testTableWrap">
									<table className="testTable">
										<colgroup>
											<col width="3%"/>
											<col width="5%"/>
											<col width="7%"/>
											<col width="15%"/>
											<col width="12%"/>
											<col width="15%"/>
											<col width="10%"/>
											<col width="10%"/>
											<col width="10%"/>
											<col width="5%"/>
											<col width="8%"/>
											<col width="8%"/>
										</colgroup>
										<thead>
										<tr>
											<th>
												<div className="formCheckbox">
													<input type="checkbox" id="tableSelectAll" required
																 onChange={e => {
																	 if (e.target.checked) {
																		 setSelected(applyTests?.map(item => item?.id))
																	 } else {
																		 setSelected([])
																	 }
																 }}
													/>
													<label htmlFor="tableSelectAll"></label>
												</div>
											</th>
											<th>이름</th>
											<th>생년월일</th>
											<th>성별</th>
											<th>개인고유번호</th>
											<th>소속기관</th>
											<th>이메일</th>
											<th>휴대폰 번호</th>
											<th>규준집단</th>
											<th>검사일</th>
											<th>결과 내보내기</th>
											<th>결과 발송하기</th>
										</tr>
										</thead>
										<tbody>
										{applyTests?.map((item, index) => {
											return (
												<tr>
													<td>
														<div className="formCheckbox">
															<input type="checkbox" id={`tableSelect${index}`} checked={selected?.indexOf(item?.id) !== -1} onChange={e => onSelected(e.target.checked, item?.id)}/>
															<label htmlFor={`tableSelect${index}`}></label>
														</div>
													</td>
													<td>{item?.name}</td>
													<td>{item?.birth}</td>
													<td>{item?.gender}</td>
													<td>{item?.applyNumber}</td>
													{/*<td>{getCode(item?.code)}</td>*/}
													<td>{item?.organization}</td>
													<td>{item?.email}</td>
													<td>{item?.phone}</td>
													<td>{item?.group}</td>
													<td>{getDateString(new Date(item?.doneDateTime))}</td>
													{/*<td>*/}
													{/*	<button type="button" className="viewBtn" */}
													{/*					onClick={e => {*/}
													{/*		e.preventDefault()*/}
													{/*		navigate(`/test-results/${item?.id}`)*/}
													{/*	}}>*/}
													{/*		보기*/}
													{/*	</button>*/}
													{/*</td>*/}
													<td>
														<button type="button" className="saveBtn"
																		onClick={e => {
																			e.preventDefault()
																			window.open(`/test-results/${item?.id}`)
																		}}
														>
															저장
														</button>
													</td>
													<td>
														<button type="button" className="saveBtn"
																		onClick={() => sendResult([item?.id])}
														>
															발송
														</button>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</div>
								{/*<div className="testBtnWrap">*/}
								{/*	<button type="button">취소</button>*/}
								{/*	<button type="button" className="keyBtn">*/}
								{/*		생성하기*/}
								{/*	</button>*/}
								{/*</div>*/}
							</form>
						</section>
					</div>
				</div>
			</div>
			<RightFooter />
			{isLoading && (
				<ClipLoader
					color={'#333'}
					loading={isLoading}
					cssOverride={{
						position: "fixed",
						display: "block",
						margin: "0 auto",
						top: 300,
						left: '50%'
					}}
					size={100}
					aria-label="Loading Spinner"
					data-testid="loader"
				/>
			)}
			{/*<Modal*/}
			{/*	isOpen={open}*/}
			{/*	onRequestClose={() => setOpen(false)}*/}
			{/*>*/}
			{/*	<div ref={testResult}>*/}
			{/*		<TestResult id={id}/>*/}
			{/*	</div>*/}
			{/*</Modal>*/}
		</div>
	)
}

export default PersonalResult
